import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ConsultasporestadoService {
  constructor(private http: HttpClient) { }

  getNorte() {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Figureformonthestado?Zona=Norte");
  }
  getCentro() {
     return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Figureformonthestado?Zona=Centro");
  }
  getSur() {
    return this.http.get("https://fundacionbest.org.mx/Webapi/contenidoauto/api/Figureformonthestado?Zona=Sur");
  }

}
